require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2009-09-02-crazier-than-expected.json") })
        }
      }, "path---articles-2009-09-02-crazier-than-expected");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2009-09-02-crazier-than-expected!./.cache/json/articles-2009-09-02-crazier-than-expected.json
// module id = 577
// module chunks = 231608221292675